<template>
  <div class="columns" style="margin-top: 3rem;">
    <div class="column" :class="size ? size : 'is-4'">
      <p class="subtitle is-5">
        {{ title }}
      </p>

      <slot name="description"></slot>
    </div>

    <div class="column">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "size"]
};
</script>
